import React, { useState } from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import '../Assets/Css/product.css';
import productbanner from '../Assets/Images/banner1.avif';


import securityImg from '../Assets/Images/Securityservice.avif';
import bodyguardImg from '../Assets/Images/Personal Bodyguards.avif';
import auditImg from '../Assets/Images/Security Audit.jpg';
import detectiveImg from '../Assets/Images/Private Detective Services.avif';
import enquiryImg from '../Assets/Images/personal.avif';
import economicImg from '../Assets/Images/Economic Investigation.avif';
import cyberImg from '../Assets/Images/Cyber Crime Investigation.avif';
import expertImg from '../Assets/Images/Expert Advice.avif';
import policeImg from '../Assets/Images/Police Department.avif';
import { MdKeyboardArrowRight } from "react-icons/md";

import { Helmet } from "react-helmet";


const sections = [
  {
    title: 'Security Services',
    description:
      "Today's threats to companies are increasingly complex and intense at a time when business operations are becoming more interrelated and global. Investment in security can help significantly reduce a company's vulnerability to many factors that threaten performance Security Guarding Services . Are you looking for a top security company nearby? You have come to the right place. India’s leading security services company that provides the finest security services all over India. We have been in the security industry for more than 30 years, and we are known for delivering well-trained security guards and other security services to our clients in different parts of the country.",
    image: securityImg,
  },
  {
    title: 'Personal Bodyguards',
    description:
      "Sumanik Security & Allied Services Pvt. Ltd. offer wide range of security services that includes personal body guards for VIP's protection as well. We have some of our professional bodyguard taken from the team of Special Forces. They are capable to execute their services in a competent manner. We provide rigorous training to such professional security guards before they are deployed for respective jobs. It becomes essential to ensure the security,",
    image: bodyguardImg,
  },
  {
    title: 'Security Audit',
    description:
      "Our organization is engaged in offering a wide assortment of Security Audit services to our clients. These services are rendered by professionals. In addition to this, these audit services are executed at industry-leading rates to provide optimum customer satisfaction.",
    image: auditImg,
  },
  {
    title: 'Private Detective Services',
    description:
      "Sumanik Services is top most private detective agency, Matrimonial detective agency, Personal detective agency & Corporate investigation agency in Nashik and having many years of involvement in this field. prominent as an expert society and quality conscious firm and they are flexible in offering specific services for both non-business (individual) and organizations.",
    image: detectiveImg,
  },
  {
    title: 'Personal Enquires',
    description:
      "Sumanik Services is one of the largest private Personal Enquires firms in India that offers a comprehensive range of personal investigation and detective services. Our private Enquires work legitimately to offer various investigation services to a range of clients, such as corporate, individuals, celebrities, high net-worth individuals, government bodies, etc.",
    image: enquiryImg,
  },
  {
    title: 'Economic Investigation',
    description:
      "Investigation of fraud, corruption and other economic crime requires a thorough, professional and independent approach. In the course of our forensic investigations, we usually review financial and nonfinancial data, conduct interviews, capture and review electronic files, explore open source information, aimed at detecting potential indications of fraud and other wrongdoings, as well as to estimate their span, scale and subjects involved. In our work we also use specialised forensic technology solutions for securing and processing data which helps us to streamline and bring better efficiency into investigation process.",
    image: economicImg,
  },
  {
    title: 'Cyber Crime Investigation',
    description:
      "Sumanik Services is a highly experienced investigation and forensic firm that helps Corporations, Small Businesses, and Individuals address unwanted cyber issues impacting their lives. Each year we receive thousands of requests for help that range from Cyber Harassment, Unlawful computer Intrusions, Invasion of Privacy, Extortion, Internet Fraud, Trademark Infringement, Defamation, Copyright Infringement and Intellectual Property Theft. Each day we are seeing more and more advanced strategies that cyber criminals are using to hide their identity, use as attack platforms, and to disrupt, destroy or harm peoples businesses and lives.",
    image: cyberImg,
  },
  {
    title: 'Expert Advice',
    description:
      "We have helped advise seeking organizations & Individuals globally and across industries and functions. Our consultants engage with participants through email, phone, virtual conference and also face to face meetings.",
    image: expertImg,
  },
  {
    title: 'Police Department',
    description: 
    "Specialized support services in collaboration with police and enforcement agencies.",
    image: policeImg,
  },
];

  
  
 


  
  
  
export default function ProductPage() {

    const [activeIndex, setActiveIndex] = useState(0);

    

  return (
    <>
    <div className="mainnav">

    <Helmet>
      <title>Our Services | Sumanik Security And Allied Services Pvt Ltd</title>
      <meta
        name="description"
        content="Explore a complete range of certified security solutions by Sumanik Security, including guarding services, bodyguards, cyber investigations, and more — backed by 30+ years of experience."
      />
      <meta
        name="keywords"
        content="Security Services India, Bodyguards Pune, Cyber Crime Investigation, Private Detective India, Security Audit, Economic Investigation, Sumanik Security"
      />
      <meta name="author" content="Sumanik Security And Allied Services Pvt Ltd" />
      <meta property="og:title" content="Security Services Across India | Sumanik Security Pvt Ltd" />
      <meta
        property="og:description"
        content="India’s leading certified security company providing well-trained guards, audits, detective services, and cyber crime solutions nationwide."
      />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://www.sumaniksecurity.com/services" />
      <meta property="og:image" content="https://www.sumaniksecurity.com/images/services-og.jpg" />
    </Helmet>

{/* Banner Section */}
<div className="about-banner position-relative text-white mb-4">
  <img
    src={productbanner}
    alt="About Banner"
    className="aboutbanner-image animate-banner-zoom"
  />
  <div className="maindesc position-absolute top-50 start-50 translate-middle  px-1">
    <h2 className="fw-bold glitch" data-text=" Explore Our Premium Product">
     Our Services - Sumanik Security and Allied Services Pvt Ltd
    </h2>
   
  </div>
</div>


<Container className="mb-2">
  <h2 className="Mainhead">Services We Provide</h2>

  <Container className="my-4">
      

<Row className="custom-row">
  {sections.map((product, index) => (
    <Col key={index} className="custom-col mb-3">
      <Card className="h-100 orgproduct shadow-sm">
        <Card.Img variant="top" src={product.image} style={{ height: '180px', objectFit: 'fill' }} />
        <Card.Body>
          <h4 className="text-center fs-6" >{product.title}</h4>
        </Card.Body>
      </Card>
    </Col>
  ))}
</Row>
    </Container>

<Container className="py-4 mt-5">
      <Row className="justify-content-center">
<Col md={11} className="productcard rounded-4 p-0">
  <Row className="g-3">
    
<Col md={4} className="px-4 bg-white title-column">
  <div className="p-3 rounded-3 title-column-inner">
    {sections.map((section, idx) => (
      <div key={idx}>
        <Button
          variant="transparent"
          className={`w-100 text-start mb-0 rounded-3 fw-semibold fs-6 title-button ${
            idx === activeIndex ? 'active-title' : ''
          }`}
          onClick={() => setActiveIndex(idx)}
        >
          <MdKeyboardArrowRight size={20} /> {section.title}
        </Button>
        <div className="borderline my-3"></div>
      </div>
    ))}
  </div>
</Col>


    
    <Col
      md={8}
      className="p-4 bg-white productrightcard"
      style={{
        borderTopRightRadius: '16px',
        borderBottomRightRadius: '16px',
        boxShadow: '0 4px 16px rgba(0, 0, 0, 0.3)',
      }}
    >
      <Card className="border-0">
        <h4 className='text-center' style={{ color: '#DCAB34', fontWeight: 'bold' }}>{sections[activeIndex].title}</h4>
        <Card.Body>{sections[activeIndex].description}</Card.Body>
      </Card> 
    </Col>
  </Row>
</Col>
      </Row>
    </Container>


</Container>
</div>
    
    </>
  );
}
